module.exports = __webpack_public_path__ + "img/xiao.426dbfc3.png";